import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyD55hvd9uOzo-RsMBCIAEwbfIpZ-IYqhws",
  authDomain: "resuranker-main.firebaseapp.com",
  projectId: "resuranker-main",
  storageBucket: "resuranker-main.firebasestorage.app",
  messagingSenderId: "197288418200",
  appId: "1:197288418200:web:ca58e0571d8132544729ed",
  measurementId: "G-SG64B287JE"
};

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  
  // Initialize Firebase Authentication and get a reference to the service
  const auth = getAuth(app);
  
  // Set the persistence
  setPersistence(auth, browserLocalPersistence)
    .then(() => {
      // Now the auth state will be persisted in the local storage and will survive browser refreshes
    })
    .catch((error) => {
      console.error("Error setting persistence:", error);
    });
  
  export { auth };